module.exports = __webpack_public_path__ + "static/img/preview-07.643bbcc4.webp";